import { Notification } from "../atoms/notification";
import { Search } from "../atoms/search";
import { User } from "../atoms/user";
import { SidebarToggle } from '../atoms/sidebartoggle';
import { CreditButton } from "../molecule/creditButton";
import { GoBackButton, StandardButton } from "../atoms/buttons";
import { PageContext } from "../App";
import { useContext, useEffect, useState } from "react";
import { ip } from "../api/api";
import defaultLogo from "../assets/expligo_logo.png"
import { icon } from "../functions/icons";

export function TopBar({user,notification,onSearchChange,searchValue,goProfile, searchRef, toggleSidebar, activateCredit, isQuizActive,logo, hide= false }){
    var avatarSrc = user.avatar_url ? user.avatar_url : `https://ui-avatars.com/api/?name=${user.full_name}&background=random&color=fff&format=svg`;
    const navigationContext = useContext(PageContext)
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const isMobile = windowWidth < 768;
    useEffect(() => {
        const onResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);
    const handleGoBack = () => {
        navigationContext.handleNavigation({ courseID: navigationContext.sidebar.courseID, navigation: 7, enrollment: 0 });
      };
    const inAssessment = navigationContext.sidebar.navigation === 10;
    return(
        !hide && (<div className="horizontal topbar-background-color complete-width space-between clickable-topbar">
            {inAssessment && isMobile && <StandardButton backgroundColor="error-600" onClick={() => navigationContext.handleNavigation({ courseID: navigationContext.sidebar.courseID, navigation: 7, enrollment: 0 })} title={<>{icon("door-exit")}</>}></StandardButton>}
            {isQuizActive ? ( <></> ) : ( <>  <SidebarToggle toggleSidebar={toggleSidebar} /> <Search inputRef={searchRef} value={searchValue} onChange={onSearchChange} /> </> )}
            {/* <CreditButton activateCredit={activateCredit}/>  */}
            {/* <Notification notifcation={notification}/> */}
            {isQuizActive && ( <img style={{ height: "3.1rem", objectFit: "contain" }}   src={logo ? `${ip}/api/media/${logo}` : defaultLogo}   alt="logo"/>)}
            <User goProfile={goProfile} avatar={avatarSrc} name={user?.full_name} email={user.email}/>
        </div>)
    )
}